import { render } from "./SystemTabRecursos.vue?vue&type=template&id=4d27f828&scoped=true&ts=true"
import script from "./SystemTabRecursos.vue?vue&type=script&lang=ts"
export * from "./SystemTabRecursos.vue?vue&type=script&lang=ts"

import "./SystemTabRecursos.vue?vue&type=style&index=0&id=4d27f828&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d27f828"]])

export default __exports__